import React from "react"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W6",
  lineHeight: "normal",
  letterSpacing: "normal",
  color: "#727272",
  fontSize: "18px",
  [theme.breakpoints.down("xs")]: {
    fontSize: "15px",
  },
}))

const HeaderTitle = (props) => {
  return <StyledTypography>{props.children}</StyledTypography>
}

export default HeaderTitle
